import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { SchemaNode } from '../../models'

import type { SchemaVoidSpecific } from '@rehaje/core'

export class SchemaVoidNode extends SchemaNode {
  @fromSpecific()
  @reactive('shallow')
  types: SchemaNode[] = []

  constructor(specific: SchemaVoidSpecific) {
    super({
      ...specific,
      // @ts-ignore
      types: specific.types ?? specific['children']
    })
  }
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Void': SchemaVoidNode
  }
}
